// Time shorthands which can help with readability.
export const ONE_SECOND = 1000;
export const ONE_MINUTE = 60 * 1000;
export const ONE_HOUR = 60 * ONE_MINUTE;
export const ONE_DAY = 24 * ONE_HOUR;
export const ONE_YEAR = 365 * ONE_DAY;

// Intentionally using en-US because we are not attempting to localize at this
// time.
export const DATE_TIME_LOCALE = 'en-US';
